<template>
  <div>
    <v-row no-gutters>
      <v-col>
        <v-btn
          data-id-e2e="btnNewWorkpackage"
          data-dd-action-name="AddNewWorkpackageBtn"
          primary
          class="mr-2"
          :disabled="isNewButtonDisabled"
          @click="addNewWorkpackage"
        >
          {{ $t('workpackagePage.newWpButton') }}
        </v-btn>
        <v-btn
          v-if="templatesEnabled"
          data-id-e2e="btnNewWorkpackageFromTemplate"
          data-dd-action-name="AddNewWorkpackageFromTemplateBtn"
          primary
          :disabled="isNewButtonDisabled"
          @click="createNewWorkpackageFromTemplate"
        >
          {{ $t('workpackagePage.newWpFromTemplateButton') }}
        </v-btn>
      </v-col>
    </v-row>
    <WorkpackagesTemplatesModal
      v-model="isWorkpackageTemplatesModalOpen"
      @close="closeWorkpackageTemplatesModal"
    />
  </div>
</template>

<script>
import { get } from 'lodash';
import { mapActions, mapState } from 'pinia';
import { useFeature } from '@/composables/use-feature';
import { usePermission } from '@/composables/use-permission';
import { useDomUtility } from '@/composables/dom-utils';
// Stores
import { useWorkpackagesStore } from '@/stores/workpackages';
import { useBundlesStore } from '@/stores/bundles';

export default {
  setup() {
    const { canCreateWorkpackage } = usePermission();
    const { templatesEnabled } = useFeature();
    const { scrollToElement } = useDomUtility();

    return {
      canCreateWorkpackage,
      templatesEnabled,
      scrollToElement,
    };
  },
  data() {
    return { isWorkpackageTemplatesModalOpen: false };
  },

  computed: {
    ...mapState(useBundlesStore, ['selectedBundle']),

    ...mapState(useWorkpackagesStore, ['activeWorkpackages']),

    bundleId() {
      return get(this.selectedBundle, '_id');
    },

    isNewButtonDisabled() {
      return (
        (this.activeWorkpackages.length &&
          !this.activeWorkpackages[this.activeWorkpackages.length - 1]._id) ||
        !this.canCreateWorkpackage
      );
    },
  },

  methods: {
    ...mapActions(useWorkpackagesStore, ['addWorkpackage']),

    async addNewWorkpackage() {
      const addedWorkpackage = await this.addWorkpackage({ bundleId: this.bundleId });
      this.scrollToElement(`wp-list-element-${addedWorkpackage._id}`);
    },

    createNewWorkpackageFromTemplate() {
      this.isWorkpackageTemplatesModalOpen = true;
    },

    closeWorkpackageTemplatesModal() {
      this.isWorkpackageTemplatesModalOpen = false;
    },
  },
};
</script>
